import React, { Component, PropTypes } from 'react';

export default class InputField extends Component {
    static propTypes = {
        val: PropTypes.any.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : ''
    };

    componentDidMount() {
        this.setState({
            val: this.props.val
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handleChange = (e) => {
        this.setState({val : e.target.value});
        if(this.props.passValue) {
            this.props.passValue(e);
        }

        if(this.props.onChange) {
            this.props.onChange(e);
        }
    }

    render() {
        var className = this.state.val ? 'form-control edited' : 'form-control';
        let helperClass = this.state.val ? 'help-block hidden   ' : 'help-block';
        let hasError = '';

        if(this.props.hasError === true) {
            hasError = 'has-error';
        }

        return (
            <div className={'form-group form-md-line-input ' + this.props.id + ' ' + hasError}>
                <input type={this.props.type} className={className} id={this.props.id}
                       name={this.props.id}
                       onChange={this.handleChange}
                       value={this.state.val} />

                <label htmlFor={this.props.id}
                       style={this.props.customLabelStyle}>{this.props.label}</label>
                <span className={helperClass}>{this.props.help}</span>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/InputField.js
 **/